export const FUNDS_TRANSACTION_PAGE_SIZE = 30;
export const TRANSACTION_SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC",
};
export const END_OF_RESPONSE = "End_of_Response";
export const FUNDS_TSTORE = {
  VIEW: process.env.GATSBY_FUNDS_TSTORE_VIEW,
  VIEW_VERSION:
    process.env.GATSBY_FUNDS_TSTORE_VIEW_VERSION,
};

export const ICON_MAPS = {
  DEPOSIT_ICON: "DEPOSIT_ICON",
  ACC_OPENING_ICON: "ACC_OPENING_ICON",
  WITHDRAW_ICON: "WITHDRAW_ICON",
};

export const TIMELINE_STATE = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  ERRORED: "ERRORED",
};

export const TIMELINE_TYPE = {
  SUBMITTED: "SUBMITTED",
  ACCEPTED: "ACCEPTED",
  PROCESSED: "PROCESSED",
  CANCELLED: "CANCELLED",
};

export const TRANSACTION_UI_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  COMPLETED: "COMPLETED",
  ERRORED: "FAILED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
};

export const TRANSACTION_STATE = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  ERRORED: "ERRORED",
};

export const VIEW_ENTITY_TYPE = {
  SPONSOR_DEBIT_TRANSACTION: "SPONSOR_DEBIT_TRANSACTION",
  SPONSOR_CREDIT_TRANSACTION: "SPONSOR_CREDIT_TRANSACTION",
  SENT_PAYMENT: "SENT_PAYMENT",
  ONBOARDING_PLAN_TRANSACTION:
    "ONBOARDING_PLAN_TRANSACTION",
};

export const TRANSACTION_TABLE_ENTITY_TYPE = {
  ACCOUNT_OPENING_FEE: "ACCOUNT_OPENING_FEE",
  DEPOSIT: "DEPOSIT",
  MONTHLY_AUTO_WITHDRAWAL: "MONTHLY_AUTO_WITHDRAWAL",
  QUARTERLY_AUTO_WITHDRAWAL: "QUARTERLY_AUTO_WITHDRAWAL",
  WITHDRAWAL: "WITHDRAWAL",
};

export const TRANSACTION_TABLE_ENTITY_TYPE_MAP = {
  [TRANSACTION_TABLE_ENTITY_TYPE.ACCOUNT_OPENING_FEE]:
    "Account opening fee",
  [TRANSACTION_TABLE_ENTITY_TYPE.DEPOSIT]: "Deposit",
  [TRANSACTION_TABLE_ENTITY_TYPE.MONTHLY_AUTO_WITHDRAWAL]:
    "Periodic auto-withdrawal",
  [TRANSACTION_TABLE_ENTITY_TYPE.QUARTERLY_AUTO_WITHDRAWAL]:
    "Periodic auto-withdrawal",
  [TRANSACTION_TABLE_ENTITY_TYPE.WITHDRAWAL]: "Withdrawal",
};

export const AUTO_WITHDRAW_FREQUENCY = {
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
};

export const WITHDRAW_INITIATED_BY = {
  USER: "USER",
  PROVIDER: "PROVIDER",
};

export const FAQ_TXN_STATE = {
  SUCCESS: "success",
  FAILED: "failed",
  PENDING: "pending",
};
